import React from 'react'
import '../App.css';

function AboutRoadMap(){
    return(
        <div className="section bg--black about-road__section">
            <div className="about-roadmap__container container--center">
                <h2 className="about-roadmap__header">
                     Discover Our Journey 
                </h2>
                <span className="btn btn--blue-black about-roadmap__btn">Roadmap</span>
            </div>
           </div>
    )
    }

export default AboutRoadMap;    